import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Compose a Unicode regional-indicator flag emoji from an ISO-3166 alpha-2
 * code. "BR" → "🇧🇷". Returns "" for a missing/invalid code so callers can
 * safely chain into a template string.
 */
export function flagEmoji(iso_a2) {
  if (!iso_a2 || iso_a2.length !== 2) return "";
  const A = 0x1F1E6 - "A".charCodeAt(0);
  const [c1, c2] = iso_a2.toUpperCase();
  return String.fromCodePoint(c1.charCodeAt(0) + A) +
         String.fromCodePoint(c2.charCodeAt(0) + A);
}

/**
 * Public CDN URL for a country flag as a crisp raster image. Works on every
 * OS (Windows lacks the emoji flags used by `flagEmoji`), retina-friendly.
 * `size` maps to flagcdn width buckets: 20, 40, 80, 160, 320, 640, 1280.
 */
export function flagUrl(iso_a2, size = 80) {
  if (!iso_a2 || iso_a2.length !== 2) return null;
  return `https://flagcdn.com/w${size}/${iso_a2.toLowerCase()}.png`;
}
